import React from 'react';
import { Route, Redirect } from 'react-router';
import { HashRouter } from 'react-router-dom';
import PrivateRoute from './PrivateRoute';
import SuperAdminPrivateRoute from './SuperAdminPrivateRoute';

import Login from '../containers/Login';
import Register from '../containers/Register';
import ForgotPasswordRequest from '../containers/ForgotPasswordRequest';
import ForgotPasswordReset from '../containers/ForgotPasswordReset';
import RegisterContact from '../containers/RegisterContact';
import RegisterPaymentPlans from '../containers/RegisterPaymentPlans';
import RegisterPaymentInfo from '../containers/RegisterPaymentInfo';
import NewProductPage from '../containers/Product/NewProduct';
import ProductsDomain from '../containers/Product/ProductsDomain';
import EditProductNewPage from '../containers/Product/EditProduct';
// import NotFound from './containers/Generic/NotFound';

import MyProfilePage from '../containers/Profile/MyProfile';
import UpgradeSubscriptionPage from '../containers/Profile/UpgradeSubscription';

// super admin components
import SuperDashboard from '../containers/SuperAdmin/SuperDashboard'
import SuperAdminDomains from '../containers/SuperAdmin/SuperAdminDomains'
import SuperAdminStatistics from '../containers/SuperAdmin/SuperAdminStatistics'
import SuperAdminPayments from '../containers/SuperAdmin/Invoices'
import SuperAdminReports from '../containers/SuperAdmin/SuperAdminReports'
import SuperAdminStoryRequests from '../containers/SuperAdmin/SuperAdminStoryRequests'
import SuperAdminSettings from '../containers/SuperAdmin/SuperAdminSettings'

import Stories from '../containers/Stories/Stories'
import NewStory from '../containers/Stories/NewStory'
import UpdateStory from '../containers/Stories/UpdateStory'

// misc pages
import TermsAndConditions from '../containers/TermsAndConditions'

import RequestsPage from '../containers/Request/Requests';
import NotificationsPage from '../containers/Notification/Notifications';
import StatisticsPage from '../containers/Statistics/Statistics';

const Home = () => <Redirect to="/login" />;

const routes = (
  <HashRouter>
    <div>
      <Route path="/" exact component={Home} />
      <Route path="/login" exact component={Login} />
      <Route path="/register" exact component={Register} />
      <Route path="/request-forgot-password" exact component={ForgotPasswordRequest} />
      <Route path="/forgot-password/:token" exact component={ForgotPasswordReset} />
      <Route path="/terms-and-conditions" exact component={TermsAndConditions} />

      <Route path="/register/contact-info" exact component={RegisterContact} />
      <Route path="/register/payment-plans" exact component={RegisterPaymentPlans} />
      <Route path="/register/payment-info" exact component={RegisterPaymentInfo} />

      <PrivateRoute path="/dashboard" exact component={Stories} />

      <PrivateRoute path="/products-new" exact component={NewProductPage} />
      <PrivateRoute path="/products/:id" exact component={EditProductNewPage} />
      <PrivateRoute path="/products" exact component={ProductsDomain} />

      <PrivateRoute path="/stories/update/:storyId" exact component={UpdateStory} />
      <PrivateRoute path="/stories/new" exact component={NewStory} />
      <PrivateRoute path="/stories" exact component={Stories} />

      <PrivateRoute path="/notifications" exact component={NotificationsPage} />
      <PrivateRoute path="/messages" exact component={RequestsPage} />
      <PrivateRoute path="/statistics" exact component={StatisticsPage} />

      <PrivateRoute path="/my-account" exact component={MyProfilePage} />
      <PrivateRoute path="/payment-plans/:domain/:type" exact component={UpgradeSubscriptionPage} />

      <SuperAdminPrivateRoute path="/s/dashboard" exact component={SuperDashboard} />
      <SuperAdminPrivateRoute path="/s/domains" exact component={SuperAdminDomains} />
      <SuperAdminPrivateRoute path="/s/messages" exact component={SuperAdminReports} />
      <SuperAdminPrivateRoute path="/s/payments" exact component={SuperAdminPayments} />
      <SuperAdminPrivateRoute path="/s/statistics" exact component={SuperAdminStatistics} />
      <SuperAdminPrivateRoute path="/s/story-requests" exact component={SuperAdminStoryRequests} />
      <SuperAdminPrivateRoute path="/s/settings" exact component={SuperAdminSettings} />
    </div>
  </HashRouter>
);

export default routes;



// WEBPACK FOOTER //
// ./src/routes/index.js